<template>
  <div id="name" class="container">
    <Question :question="question">
      <div class="form-group">
        <div class="input-group">
          <div class="input-group-prepend">
            <span class="input-group-text">Name</span>
          </div>
          <input type="text" class="form-control" v-model="emergencyContactName" required>
        </div>
        <br>
        <div class="input-group">
          <div class="input-group-prepend">
            <span class="input-group-text">Phone</span>
          </div>
          <input type="number" max="9999999999" min="1000000000" class="form-control" v-model="emergencyContactPhone">
        </div>
        <br>
        <div class="input-group">
          <div class="input-group-prepend">
            <span class="input-group-text">Address</span>
          </div>
          <textarea class="form-control" v-model="emergencyContactAddress"></textarea>
        </div>
      </div>
    </Question>
  </div>
</template>

<script>
import Question from "../Question.vue";

export default {
  name: "EmergencyContact",
  components: {
    Question
  },
  props: {
      question: String
  },
  data: function() {
    return { 
        emergencyContactName: "", 
        emergencyContactPhone: "", 
        emergencyContactAddress: "" 
    };
  }
};
</script>